import React from 'react';
import PropTypes from 'prop-types';
import EmptyBlock from '../EmptyBlock';
import { NBSP } from '../../../../constants/common';

const EmptyAboutHotel = ({ isMobile }) => (
  <EmptyBlock
    isMobile={isMobile}
    title="Нет информации об отеле"
    description={`Этот отель новый или в${NBSP}нем отдыхало не${NBSP}так много${NBSP}туристов`}
  />
);

EmptyAboutHotel.propTypes = {
  isMobile: PropTypes.bool,
};
EmptyAboutHotel.defaultProps = {
  isMobile: false,
};

export default EmptyAboutHotel;
